import {AwpDmsInterfaceFactoryUtils} from '../../rest-api/awp-dms-interface-factory-utils';
import {GetCustomerRequest} from './get-customer-request';
import {GetCustomerRequestBody} from './get-customer-request-body';

export class AwpDmsInterfaceGetCustomerRequestFactory {
  createRequest(dmsCustomerId: string, maxVehicleResults: number, locale: string, dpNo: string, outletNo: string): GetCustomerRequest {
    const schema = 'awp-dms-get-customer-request';
    const version = '1.0.0';
    const request = new GetCustomerRequest();
    request.functionalHeader = AwpDmsInterfaceFactoryUtils.createFunctionalHeaderFromPrimitives(dpNo, outletNo);
    request.technicalHeader = AwpDmsInterfaceFactoryUtils.createTechnicalHeaderInRequest(schema, version);
    request.userInformation = AwpDmsInterfaceFactoryUtils.createUserInformationFromPrimitive(locale);
    request.body = this.createRequestBody(dmsCustomerId, maxVehicleResults);
    return request;
  }

  private createRequestBody(dmsCustomerId: string, maxVehicleResults?: number): GetCustomerRequestBody {
    const body = new GetCustomerRequestBody();
    body.dmsCustomerId = dmsCustomerId;
    if (maxVehicleResults != null) {
      body.maxVehicleResults = maxVehicleResults;
    }
    return body;
  }
}
